import {
  REGISTRO_ERROR,
  REGISTRO_SUCCESS,
  REGISTRO_LOADING,
  REGISTRO_SETUSUARIO,
  REGISTRO_LOGOUT,
  REGISTRO_SETERRORUSUARIO,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import registroInitialState from "../initialStates/registroInitialState";

const registro = (state, { payload, type }) => {
  switch (type) {
    case REGISTRO_SETUSUARIO:
      return {
        ...state,
        registro: {
          ...state.registro,
          usuario: payload,
        },
      };
    case REGISTRO_SETERRORUSUARIO:
      return {
        ...state,
        registro: {
          ...state.registro,
          listError: payload,
        },
      };
    case REGISTRO_LOADING:
      return {
        ...state,
        registro: {
          ...state.registro,
          error: false,
          loading: true,
        },
      };
    case REGISTRO_SUCCESS:
      return {
        ...state,
        registro: {
          ...state.registro,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case REGISTRO_ERROR:
      return {
        ...state,
        registro: {
          ...state.registro,
          error: payload,
          loading: false,
        },
      };
    case REGISTRO_LOGOUT:
      return registroInitialState;
    case RESET_PORTAL_CONTEXT:
      return registroInitialState;
    default:
      return state;
  }
};

export default registro;
